import { useState } from "react";

import ReactPaginate from "react-paginate";

import OrderItem from "./OrderItem";

export default function OrderList({
  data,
  statusList,
  setOrderListUpdater,
  orderListTotal,
  orderListFunc,
  filterFlag,
  filterDataValid,
}) {
  const [pagination, setPagination] = useState(1);
  return (
    <div className="order-list">
      {data.map((value) => {
        return (
          <OrderItem
            itemsData={value}
            statusList={statusList}
            setOrderListUpdater={setOrderListUpdater}
          />
        );
      })}
      <div className=" d-flex justify-content-center mt-3">
        <ReactPaginate
          // forcePage={pagination}
          previousLabel={"قبلی"}
          nextLabel={"بعدی"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={Math.ceil(orderListTotal / 10)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={2}
          onPageChange={(e) => {
            setPagination(e.selected);
            if (filterFlag) {
              orderListFunc(filterDataValid, e.selected + 1);
            } else {
              orderListFunc({}, e.selected + 1);
            }
          }}
          containerClassName="pagination mx-auto mb-3"
          activeLinkClassName="text-white"
          activeClassName="bg-info style-activeClass"
          pageClassName="style-pageClass mx-2 border border-1"
          pageLinkClassName="page-link style-page-link"
          nextClassName="border btn mx-1 px-4 py-1 "
          previousClassName="border btn mx-1 px-4 py-1  "
          nextLinkClassName="style-nextLink "
          previousLinkClassName="style-previousLink "
        />
      </div>
    </div>
  );
}
